import { ValidationProps, ValidationLevel, ValidationMessage } from 'ui/common/validation/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';

export const getLanguageValidation = (
  validation: ValidationProps,
  languageId: number,
  valueKey: string
): ValidationProps => {
  const validationMessage: ValidationMessage = isDefinedIncludingZero(languageId)
    ? validation?.messages?.find(validationValue =>
      !!validationValue.parameters && validationValue.parameters[valueKey] === languageId)
    : undefined;

  return !!validationMessage ? { level: ValidationLevel.error, messages: [validationMessage] } : undefined;
};
